<noda-main-hero-v2
  data-header-class="dark"
  class="section"
/>
<noda-main-blocks-v2
  data-header-class="white"
  class="section"
/>
<noda-what-is-noda
  data-header-class="dark"
  class="section"
/>
<noda-banking-v2
  data-header-class="dark"
  class="section"
/>
<noda-reviews-v2
  data-header-class="white"
  class="section"
/>
<noda-code-v2
  data-header-class="dark"
  class="section"
/>
<noda-conditions-v2
  data-header-class="white"
  class="section"
/>
<noda-banner-market
  data-header-class="white"
  theme="white"
  class="section"
/>
<noda-geo-coverage-v2
  data-header-class="dark"
  class="section"
/>
<noda-product-block
  data-header-class="white"
  class="section"
  [data]="productsDate"
/>
